import {
  GlobalEvents,
  SnippetElement,
  defineElement,
  liquidValue
} from "./chunk-DNDL4K7L.js";
import {
  __decorateClass
} from "./chunk-XDKWOSVF.js";

// src/snippets/util-per-variant/util-per-variant.ts
var UtilPerVariant = class extends SnippetElement {
  constructor() {
    super(...arguments);
    this.templates = /* @__PURE__ */ new Map();
  }
  connectedCallback() {
    this.currentId = this.initialId;
    const form = this.closest("util-product-form");
    if (form) {
      this.form = form;
      this.form.addEventListener(
        "change",
        () => {
          var _a, _b, _c, _d, _e, _f;
          const targetId = (_f = (_b = (_a = this.form) == null ? void 0 : _a.currentVariant) == null ? void 0 : _b.id) != null ? _f : parseInt((_e = (_d = (_c = this.form) == null ? void 0 : _c.formObj) == null ? void 0 : _d.id) != null ? _e : this.initialId.toString());
          if (targetId !== this.currentId) {
            this.handleVariantChange(targetId);
          }
        }
      );
    } else {
      GlobalEvents.on(
        "product:variantChanged",
        (evt) => {
          var _a;
          const targetId = (_a = evt.detail.id) != null ? _a : this.initialId;
          if (targetId !== this.currentId) {
            this.handleVariantChange(targetId);
          }
        }
      );
    }
    this.querySelectorAll(":scope > template").forEach(
      (elm) => {
        var _a;
        const variantId = parseInt((_a = elm.getAttribute("data-variant-id")) != null ? _a : "-1");
        if (variantId && elm instanceof HTMLTemplateElement) {
          this.templates.set(variantId, elm);
          elm.remove();
        }
      }
    );
    const children = this.children;
    const template = document.createElement("template");
    for (let i = 0; i < children.length; i++) {
      template.content.appendChild(children[i].cloneNode(true));
    }
    this.templates.set(this.initialId, template);
  }
  handleVariantChange(variantId) {
    const template = this.templates.get(variantId);
    if (template) {
      this.innerHTML = "";
      this.appendChild(template.content.cloneNode(true));
      this.currentId = variantId;
      this.emit("change", { variantId });
    }
  }
};
__decorateClass([
  liquidValue("product.selected_or_first_available_variant.id")
], UtilPerVariant.prototype, "initialId", 2);
UtilPerVariant = __decorateClass([
  defineElement("util-per-variant")
], UtilPerVariant);
export {
  UtilPerVariant
};
